import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

class ContractLeftTab extends React.Component {
  renderChildren() {
    if (this.props.children) {
      return this.props.children
    } else if (this.props.isActive) {
      return (
        <i className="fa-kit fa-chevron -my-0.5 text-2xl leading-none text-yellow-600" />
      )
    } else {
      return <span>None</span>
    }
  }

  render() {
    return (
      <div
        onClick={this.props.onClick}
        className={classNames({ "cursor-pointer": this.props.isSelectable })}
      >
        <hr className="mx-6 my-0" />
        <div
          className={classNames("flex justify-between p-6", {
            "relative z-10 -m-px border border-yellow-400 bg-yellow-100":
              this.props.isActive,
          })}
        >
          <div className="text-base font-semibold leading-8">
            {this.props.title}
          </div>
          <div className="ml-2 flex flex-col items-end justify-center space-y-3">
            {this.renderChildren()}
          </div>
        </div>
      </div>
    )
  }
}

ContractLeftTab.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  isSelectable: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
}

export default ContractLeftTab
